import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import PropsType from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(theme => ({
  wrap: {
    height: '100%',
    boxShadow: '0px 8px 32px #BDD7F0',
    borderRadius: 16,
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      flexDirection: 'column'
    }
  },
  popularWrap: {
    position: 'relative',
    '&::after': {
      position: 'absolute',
      top: -8,
      right: -8,
      content: '"Most Popular"',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: 64,
      height: 64,
      fontSize: 12,
      fontWeight: 700,
      lineHeight: 1.14,
      textAlign: 'center',
      color: theme.palette.secondary.main,
      backgroundColor: '#FEE277',
      borderRadius: '50%'
    }
  },
  header: {
    position: 'relative',
    minHeight: 195,
    padding: theme.spacing(8),
    backgroundColor: theme.palette.grey[300],
    border: `1px solid ${theme.colors.borderColor}`,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    overflow: 'hidden',
    [theme.breakpoints.up('md')]: {
      paddingRight: theme.spacing(1),
      paddingLeft: theme.spacing(1)
    }
  },
  colorLine: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: 8
  },
  title: {
    marginBottom: theme.spacing(6),
    fontSize: 20
  },
  price: {
    marginBottom: theme.spacing(2),
    fontWeight: 700
  },
  text: {
    [theme.breakpoints.between('md', 'md')]: {
      fontSize: 14
    }
  },
  content: {
    minHeight: 144,
    padding: theme.spacing(8, 6),
    border: `1px solid ${theme.colors.borderColor}`,
    borderTop: 'none',
    borderBottomLeftRadius: 16,
    borderBottomRightRadius: 16,
    [theme.breakpoints.up('md')]: {
      flex: '1 0',
      paddingRight: theme.spacing(8),
      paddingLeft: theme.spacing(8)
    }
  },
  contentValue: {
    fontSize: 20,
    fontWeight: 700
  }
}));

const PlanItem = ({ data, children }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const {
    name,
    color,
    price,
    period,
    numberViews,
    nubmerExperiences,
    mostPopular
  } = data;

  return (
    <Paper
      className={clsx(classes.wrap, { [classes.popularWrap]: mostPopular })}
    >
      {/* Header */}
      <div className={classes.header}>
        <div className={classes.colorLine} style={{ backgroundColor: color }} />
        <Typography className={classes.title} variant="h3" align="center">
          {name}
        </Typography>
        <Typography className={classes.price} variant="h4" align="center">
          {price}
          {period}
        </Typography>
        {period && (
          <Typography className={classes.text} variant="body1" align="center">
            {t('whiteLabelPage.plans.text')}
          </Typography>
        )}
      </div>

      {/* Content */}
      <div className={classes.content}>
        {period && (
          <>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              width="100%"
              mb={2}
            >
              <Typography variant="body1">
                {t('whiteLabelPage.plans.views')}
                {period}
              </Typography>
              <Typography variant="body1" className={classes.contentValue}>
                {numberViews}
              </Typography>
            </Box>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              width="100%"
            >
              <Typography variant="body1">
                {t('whiteLabelPage.plans.experiences')}
              </Typography>
              <Typography variant="body1" className={classes.contentValue}>
                {nubmerExperiences}
              </Typography>
            </Box>
          </>
        )}
        <>{children}</>
      </div>
    </Paper>
  );
};

PlanItem.propTypes = {
  data: PropsType.shape({
    name: PropsType.string,
    color: PropsType.string,
    price: PropsType.string,
    period: PropsType.string,
    numberViews: PropsType.string,
    nubmerExperiences: PropsType.string,
    mostPopular: PropsType.bool
  }).isRequired,
  children: PropsType.node
};

PlanItem.defaultProps = {
  children: null
};

export default PlanItem;
